/** "Čeká na mě" on My Page and the badge, and the autonomy levels of projects and tickets. */
export const decisionsEn = {
  decisions: {
    title: "Waiting for me",
    intro: "What only you can decide or do before the work goes on, most urgent first.",
    empty: "Nothing is waiting for you.",
    loadFailed: "Couldn't load what is waiting for you.",
    badge_one: "{{count}} decision is waiting for you",
    badge_few: "{{count}} decisions are waiting for you",
    badge_other: "{{count}} decisions are waiting for you",
    kinds: {
      escalation: "An agent asks",
      "plan-approval": "Approve the plan and criteria",
      "test-gate": "Test before production ({{env}})",
      "merge-gate": "Merge into {{env}}",
      handed: "{{agent}} handed you the ticket",
      "autonomy-lowered": "Autonomy of the project lowered to {{level}}",
      batch_one: "{{count}}× {{label}}",
      batch_few: "{{count}}× {{label}}",
      batch_other: "{{count}}× {{label}}",
    },
    question: "Question",
    recommended: "Recommended",
    due: "By",
    overdue: "Overdue",
    blocks: "Waiting on it",
    blocksTickets_one: "{{count}} ticket",
    blocksTickets_few: "{{count}} tickets",
    blocksTickets_other: "{{count}} tickets",
    blocksRelease: "release {{name}}",
    blocksAgent: "an agent",
    irreversible: "Only a person",
    autonomyLowered:
      "The weekly diagnosis lowered the level after returns after merge or a production error. Keep it, or put the level back in the project settings.",
    actions: {
      "approve-plan": "Approve",
      workflow: "Tests passed",
      "return-to-agent": "Done, back to {{agent}}",
      "open-mr": "Open the MR",
      "keep-autonomy": "Keep the lower level",
      open: "Open the ticket",
      settings: "Project settings",
      show: "Show {{count}}",
      hide: "Hide",
    },
    done: "Done.",
    failed: "It didn't go through: {{error}}",
  },
  autonomy: {
    label: "Autonomy {{level}}",
    title: "Autonomy level",
    intro:
      "How much the agents do on their own. The level sets the production toggles below as a preset; a toggle changed by hand after it stays as a deviation.",
    levels: {
      "0": {
        name: "Proposals",
        text: "Agents propose. A person approves every plan with its criteria and merges at every gate.",
      },
      "1": {
        name: "Supervised",
        text: "A person approves the plan and criteria of tickets estimated over 2 h, and merges into test and production.",
      },
      "2": {
        name: "On its own up to test",
        text: "Agents plan and approve by themselves and merge into dev and test. A person tests and merges before production.",
      },
      "3": {
        name: "Full autonomy",
        text: "Agents also take low risk changes to production. Only production decisions, money, the client, access and unsettled disputes go to people.",
      },
    },
    save: "Set level",
    saved: "Level set.",
    revert: "Put back level {{level}}",
    reverted: "Previous level put back.",
    overrides: "Deviations from the level: {{keys}}",
    changedBy: "Set by {{who}}",
    changedBySettle: "Set by the one-off settle from the project's attributes",
    changedByDiagnosis: "Lowered by the weekly flow diagnosis",
    kept: "Some toggles stayed as they were: {{why}}",
    keys: {
      humanPreProductionTest: "a person tests before production",
      humanProductionMerge: "a person merges into production",
      humanEveryMerge: "a person merges at every gate",
    },
    ticket: {
      badge: "Autonomy {{level}}",
      lowered: "Lower for this ticket (project {{level}})",
      requiresApproval: "Requires approval",
      requiresApprovalHint:
        "The ticket runs at level 1: a person approves its plan and criteria and merges into test and production.",
    },
  },
};

export const decisionsCs: typeof decisionsEn = {
  decisions: {
    title: "Čeká na mě",
    intro: "Co musíš rozhodnout nebo udělat jen ty, než práce půjde dál. Nejnaléhavější nahoře.",
    empty: "Nic na tebe nečeká.",
    loadFailed: "Nepodařilo se načíst, co na tebe čeká.",
    badge_one: "Čeká na tebe {{count}} rozhodnutí",
    badge_few: "Čekají na tebe {{count}} rozhodnutí",
    badge_other: "Čeká na tebe {{count}} rozhodnutí",
    kinds: {
      escalation: "Agent se ptá",
      "plan-approval": "Schválit plán a kritéria",
      "test-gate": "Otestovat před produkcí ({{env}})",
      "merge-gate": "Mergnout do {{env}}",
      handed: "{{agent}} ti předal tiket",
      "autonomy-lowered": "Úroveň autonomie projektu snížena na {{level}}",
      batch_one: "{{count}}× {{label}}",
      batch_few: "{{count}}× {{label}}",
      batch_other: "{{count}}× {{label}}",
    },
    question: "Otázka",
    recommended: "Doporučeno",
    due: "Do",
    overdue: "Po termínu",
    blocks: "Čeká na to",
    blocksTickets_one: "{{count}} tiket",
    blocksTickets_few: "{{count}} tikety",
    blocksTickets_other: "{{count}} tiketů",
    blocksRelease: "release {{name}}",
    blocksAgent: "agent",
    irreversible: "Jen člověk",
    autonomyLowered:
      "Týdenní diagnostika snížila úroveň kvůli návratům po mergi nebo chybě v produkci. Nech ji, nebo úroveň vrať v nastavení projektu.",
    actions: {
      "approve-plan": "Schválit",
      workflow: "Test prošel",
      "return-to-agent": "Hotovo, vrátit agentovi {{agent}}",
      "open-mr": "Otevřít MR",
      "keep-autonomy": "Nechat nižší úroveň",
      open: "Otevřít tiket",
      settings: "Nastavení projektu",
      show: "Ukázat {{count}}",
      hide: "Skrýt",
    },
    done: "Hotovo.",
    failed: "Neprošlo to: {{error}}",
  },
  autonomy: {
    label: "Autonomie {{level}}",
    title: "Úroveň autonomie",
    intro:
      "Kolik agenti dělají sami. Úroveň nastaví produkční přepínače níž jako předvolbu; přepínač změněný ručně potom zůstane jako odchylka.",
    levels: {
      "0": {
        name: "Návrhy",
        text: "Agenti navrhují. Člověk schvaluje každý plán i s kritérii a merguje na každé gate.",
      },
      "1": {
        name: "Pod dohledem",
        text: "Člověk schvaluje plán a kritéria tiketů s odhadem nad 2 h a merguje do testu a do produkce.",
      },
      "2": {
        name: "Samostatně do testu",
        text: "Agenti plánují a schvalují sami a mergují do dev a test. Před produkcí testuje a merguje člověk.",
      },
      "3": {
        name: "Plná autonomie",
        text: "Agenti dávají do produkce i změny s nízkým rizikem. K lidem jde jen rozhodnutí o produkci, penězích, klientovi, přístupech a nerozhodnutý spor.",
      },
    },
    save: "Nastavit úroveň",
    saved: "Úroveň nastavena.",
    revert: "Vrátit úroveň {{level}}",
    reverted: "Předchozí úroveň vrácena.",
    overrides: "Odchylky od úrovně: {{keys}}",
    changedBy: "Nastavil(a) {{who}}",
    changedBySettle: "Nastaveno jednorázově podle toho, co je projekt zač",
    changedByDiagnosis: "Snížila týdenní diagnostika toku",
    kept: "Některé přepínače zůstaly, jak byly: {{why}}",
    keys: {
      humanPreProductionTest: "před produkcí testuje člověk",
      humanProductionMerge: "do produkce merguje člověk",
      humanEveryMerge: "na každé gate merguje člověk",
    },
    ticket: {
      badge: "Autonomie {{level}}",
      lowered: "Pro tenhle tiket nižší (projekt {{level}})",
      requiresApproval: "Vyžaduje schválení",
      requiresApprovalHint:
        "Tiket běží na úrovni 1: plán a kritéria schvaluje člověk a do testu i produkce merguje člověk.",
    },
  },
};
